import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Switch } from 'react-router-dom';

import AuthRoute from '../components/auth-route';
import Console from '../sub-projects/console/main';
import TenantsRoutes from './tenants';

class ConsoleRoutes extends React.Component<any, any> {
  public render() {
    return (
      <div>
        <Switch>
          <AuthRoute exact={true} path='/console' component={Console} redirectTo='/' />
          <AuthRoute path='/console/tenants' component={TenantsRoutes} redirectTo='/' />
          <Redirect to='/' />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default connect(
  mapStateToProps
)(ConsoleRoutes);




// WEBPACK FOOTER //
// ./src/routes/console.tsx